import { render } from "./ActiveMessages.vue?vue&type=template&id=74343b34&scoped=true&ts=true"
import script from "./ActiveMessages.vue?vue&type=script&lang=ts"
export * from "./ActiveMessages.vue?vue&type=script&lang=ts"

import "./ActiveMessages.vue?vue&type=style&index=0&id=74343b34&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74343b34"]])

export default __exports__